<template>
    <transition name="modal">
        <div class="modal-mask" v-show="show" v-shortkey="['esc']" @keyup.up="up()" @keyup.down="down()" @keyup.enter="enter()" @shortkey="$emit('close')">
            <div class="modal-container">
                <div class="modal-header">
                    <h3>Copiar procedimentos e subgrupos de outro contrato</h3>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <input type="text" class="form-control" v-model="filtros.pesquisa" placeholder="Pesquisa: Entre com NOME DA UNIDADE" @keyup.enter="getDataTable" />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <select v-model="filtros.categoria_unidade" class="form-control">
                                    <option value>--Categoria da Unidade--</option>
                                    <option value="0">Pública (Local)</option>
                                    <option value="1">Município Pactuado (PPI)</option>
                                    <option value="2">Privada</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <select v-model="filtros.tipo" class="form-control">
                                    <option value>--Tipo do Contrato--</option>
                                    <option value="0">Solicitante</option>
                                    <option value="1">Prestador</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <button @click="getDataTable" class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
                            </div>
                        </div>
                    </div>

                    <div class="row" style="margin-top:15px">
                        <div class="col-sm-12 table-responsive">
                            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                <thead>
                                    <tr role="row">
                                        <th style="width: 10%;">
                                            ID
                                            <span @click="sortByKey('contratos.id')" class="icon-ordenacao">
                                                <i :class="filtros.ordem && filtros.coluna == 'contratos.id' ? `fa fa-sort-numeric${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                            </span>
                                        </th>
                                        <th style="width: auto;">
                                            Unidade
                                            <span @click="sortByKey('unidades.nome')" class="icon-ordenacao">
                                                <i :class="filtros.ordem && filtros.coluna == 'unidades.nome' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                            </span>
                                        </th>
                                        <th style="width: auto;">Categoria</th>
                                        <th style="width: auto;">Tipo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr @click="copiar(item, index)" :class="{ ativa: index === contratoSelecionadoIndex }" class="even hand" role="row" v-for="(item, index) in dataTable.data" :key="item.id">
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.nome }}</td>
                                        <td>{{ item.categoria | categoriaUnidade }}</td>
                                        <td>{{ item.tipo | tipoContrato }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="row">
                                <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>

                                <div class="col-sm-7" style="text-align:right">
                                    <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                        <span slot="prev-nav">&lt; Anterior</span>
                                        <span slot="next-nav">Próximo &gt;</span>
                                    </laravue-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="text-right" style="float:right">
                        <button class="btn btn-default" @click="$emit('close')"><i class="fa fa-close"></i> Fechar</button>
                        <!-- <button @click="copiar()" class="btn btn-primary">
                            <span class="fa fa-check"></span>
                            Copiar
                        </button> -->
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
export default {
    props: ["show", "contratoAtualId"],
    filters: {},
    data: () => ({
        filtros: {
            pesquisa: "",
            categoria_unidade: "",
            tipo: "",
            coluna: null,
            ordem: null
        },
        dataTable: {},
        contratoSelecionadoIndex: 0
    }),
    mounted() {
        this.getDataTable();
    },
    methods: {
        sortByKey: function(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },
        getDataTable(page) {
            if (typeof page === "undefined" || typeof page === "object") {
                page = 1;
            }
            this.filtros.page = page;

            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            axios
                .get(`${this.$store.state.serverURI}/api/administracao/contratos/getAllPaginate`, config)
                .then(response => {
                    this.dataTable = response.data;
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                });
        },
        copiar(contrato, index) {
            this.contratoSelecionadoIndex = index;
            this.$swal({
                title: `Copiar os procedimentos e subgrupos do contrato de ${this.$options.filters.tipoContrato(contrato.tipo).toUpperCase()} da unidade ${contrato.nome}?`,
                html: '<b style="color: red">TODOS OS SUBGRUPOS E PROCEDIMENTOS ATUAIS SERÃO EXCLUÍDOS E ESTA OPERAÇÃO NÃO PODERÁ SER DESFEITA.</b>',
				type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                    this.$swal({
                        title: "Copiando, aguarde...",
                        imageUrl: "/static/img/Rolling-green.gif",
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });
                    axios
                        .post(
                            `${this.$store.state.serverURI}/api/administracao/contratos/copiar`,
                            {
                                contrato_origem_id: contrato.id,
                                contrato_destino_id: this.$props.contratoAtualId
                            },
                            this.$store.getters.getHeaderAuth
                        )
                        .then(response => {
                            this.$emit("close");
                            this.$swal({
                                type: "success",
                                title: "Informações copiadas com sucesso!",
                                text: "Para visualizar, vá para os procedimentos ou subgrupos deste contrato."
                            });
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        },
        up() {
            if (this.contratoSelecionadoIndex > 0) {
                this.contratoSelecionadoIndex--;
            }
        },
        down() {
            if (this.contratoSelecionadoIndex < this.dataTable.data.length - 1) {
                this.contratoSelecionadoIndex++;
            }
        },
        enter() {
            // this.seleciona(this.dataTable.data[this.contratoSelecionadoIndex]);
        }
    },
    watch: {}
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}

.modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
}

.modal-container {
    width: 70%;
    margin: 40px auto 0;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 0;
    color: #333;
}

.modal-body {
    margin: 10px 0;
}

.text-right {
    text-align: right;
}

.form-label {
    display: block;
    margin-bottom: 1em;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
			 * The following styles are auto-applied to elements with
			 * transition="modal" when their visibility is toggled
			 * by Vue.js.
			 *
			 * You can easily play with the modal transition by editing
			 * these styles.
			 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal {
    display: block !important;
    /* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
    overflow-y: initial !important;
}

.modal-body {
    height: 350px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// modalCopiarContrato.vue?2a83aa7a